<template>
	<error-page :status="status" :title="title">
		<p>
			Something went wrong on our end. We've been notified, and we'll fix it as soon as possible.
		</p>
		<btn primary raised @click="goBack">Go back</btn>
	</error-page>
</template>


<script>
    import _ from 'lodash';


	export default {
        name: 'error',
        props: {
            error: {
                type: Error,
                default: null
            }
        },
        computed: {
            status() {
                const code = _.get(this, 'error.response.status');
                if (!isNaN(code)) return code;

                return 500;
            },
            title() {
                const title = _.get(this, 'error.response.data');
                if (title && title.length) return title;

                return "Unexpected error";
            }
        },
		methods: {
			goBack() {
				this.$router.go(-1);
			}
		}
	};
</script>
